// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__943Lh","comment":"styles_comment__OUgzu"};